exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sim-filter-sidebar-form {\n  max-width: 240px;\n}\n\n.sim-table {\n  table-layout: auto;\n}", ""]);

